const register = {
    title: String("Registre"),
    welcomeMsg: String("Benvingut a AGROUPADVISOR!"),
    credentialAsk: String("Empleneu el formulari per crear un compte nou"),
    mandatoryFields: String("Els camps marcats amb (*) són obligatoris."),
    passStrength: String("Seguretat de la contrasenya"),
    passLowStrength: String("Feble"),
    passMidStrength: String("Mitja"),
    passHighStrength: String("Forta"),
    policyAgreementPrefix: String("Estic d'acord amb la"),
    policyAgreement: String("Política de privacitat"),
    createAccount: String("Crear compte"),
    forgotPass: String("Heu oblidat la vostra contrasenya?"),
    login: String("Ja tinc un compte"),
    personalDataTitle: String("Informació personal"),
    requiredFieldsMissing: String("Hi ha algun problema amb els camps obligatoris"),
    cancelButton: String("Tancar"),
    username: String("Nom d'usuari"),
    password: String("Contrasenya"),
    email: String("Correu electrònic"),
    confirmPassword: String("Confirma la contrassenya"),
    firstName: String("Nom"),
    lastName1: String("Cognom"),
    lastName2: String("Segon cognom"),
    phone: String("Telèfon"),
    nif: String("Dni o nif"),
    userSearcher: String("Introduïu la vostra adreça per reflectir les vostres dades"),
    address: String("Adreça"),
    addressNum: String("Número"),
    city: String("Ciutat"),
    province: String("Província"),
    country: String("País"),
    region: String("Regió"),
    postalCode: String("Codi Postal"),
    payAccountNumber: String("IBAN"),
    registerGoogleAskAddressPlaceholder: String("Adreça de cerca ..."),
    errorFieldRequired: String("Aquest camp és obligatori"),
    errorInvalidField: String("Camp no vàlid. Aquest camp només pot contenir lletres, guions (-) i espais."),
    errorInvalidNif: String("Format no vàlid. Aquest camp ha de contenir 8 números més una lletra. 01234567a"),
    errorFieldNumeric: String("Aquest camp només pot contenir números"),
    errorPassConfirm: String("Les contrasenyes han de ser idèntiques"),
    errorFieldEmail: String("Adreça de correu electrònic invalida."),
    errorInvalidLength: String("Número de caràcters mínims: {length}"),
    errorInvalidLengthRange: String("El nombre de caràcters hauria d'estar entre {length_min} i {length_max}"),
    errorPassStrength: String("La contrasenya ha de contenir almenys una lletra majúscula, una minúscula, un número i un símbol"),
    errorPolicyAgreement: String("L’acceptació de la política de privacitat és necessària."),
    userCreationSuccess: String("El compte s'ha creat correctament. Recordeu que el compte s’ha d’activar mitjançant el correu de confirmació."),
    userCreationFailedUsername: String("El nom del compte no s'ha creat, el nom d'usuari ja està en ús."),
    userCreationFailedEmail: String("El compte no s'ha creat, el correu electrònic ja està associat a un compte."),
};

export default register;